import React, { useEffect } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Layout from './ass_components/Layout';
import Home from './ass_pages/Home';
import TogoMap from './ass_pages/countries/togomap';
import About from './ass_pages/About';
import Coach from './ass_pages/Coach';
import Contact from './ass_pages/Contact';

import Login from './ass_pages/Login';
import WishList from './ass_pages/WishList';
import CompareProducts from './ass_pages/CompareProducts';
import ForgotPassword from './ass_pages/ForgotPassword';
import ResetPassword from './ass_pages/ResetPassword';
import ChangePassword from './ass_pages/ChangePassword';
import SetPassword from './ass_pages/SetPassword';
import PasswordChangeAlert from './ass_components/PasswordChangeAlert';
import DocumentsPendingAlert from './ass_components/DocumentsPendingAlert';
import MyDocuments from './ass_pages/account/MyDocuments';
import SearchResults from './ass_pages/SearchResults';
import SignUp from './ass_pages/SignUp';
import SignUpSaved from './ass_pages/SignUp';
import SingleBlog from './ass_pages/SingleBlog';
import Blogs from './ass_pages/Blogs';
import Cart from './ass_pages/Cart';
import './css/App.css';
import ShippingPolicy from './ass_pages/footer_links/ShippingPolicy';
import PreShippingPolicy from './ass_pages/footer_links/PreShippingPolicy';
import SingleProduct from './ass_pages/SingleProduct';
import RefundPolicy from './ass_pages/RefundPolicy';
import TermsAndConditions from './ass_pages/footer_links/TermsAndConditions';
import Checkout from './ass_pages/Checkout';
import { shallowEqual, useSelector } from 'react-redux';
import HomePastoral from './ass_pages/HomePastoral';
import GeneralInformations from "./ass_pages/footer_links/GeneralInformations";
import DeliveryPolicy from "./ass_pages/footer_links/DeliveryPolicy";
import AccountPolicy from "./ass_pages/footer_links/AccountPolicy";
import AccountSecurityPolicy from "./ass_pages/footer_links/AccountSecurityPolicy";
import PaymentPolicy from "./ass_pages/footer_links/PaymentPolicy";
import CancellationPolicy from "./ass_pages/footer_links/CancellationPolicy";
import AssigantoCargo from "./ass_pages/footer_links/AssigantoCargo";
import GettingStarted from "./ass_pages/footer_links/GettingStarted";
import AfterSignup from "./ass_pages/AfterSignup";
import HeroPackSignUp from "./ass_pages/HeroPackSignUp";
import HarvestBillingSelector from "./ass_components/payment-components/HarvestBillingSelector";
import HarvestBillingAndPaymentMethodSelector from "./ass_components/payment-components/HarvestBillingAndPaymentMethodSelector";
import Resellers from "./ass_pages/Resellers";
import ProductDetails from "./ass_pages/ProductDetails";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import HarvestBillingWithStripe from "./ass_components/payment-components/HarvestBillingWithStripe";
import StripeWrapper from "./ass_components/payment-components/StripeWrapper";
import PricingPlansImproved from "./ass_components/pricing-components/PricingPlansImproved";
import SpeculatorsPricingPlans from "./ass_components/pricing-components/SpeculatorsPricingPlans";
import TradersPricingPlans from "./ass_components/pricing-components/TradersPricingPlans";
import ProducersPricingPlansImproved from "./ass_components/pricing-components/ProducersPricingPlansImproved";
import AvailableProducersCardView from "./ass_pages/countries/AvailableProducersCardView";
import AvailableProducers from "./ass_pages/activity_domains/AvailableProducers";
import AvailableSpeculators from "./ass_pages/activity_domains/AvailableSpeculators";
import AvailableTraders from "./ass_pages/activity_domains/AvailableTraders";
import EquipmentDetails from "./ass_components/EquipmentDetails";
import HeroImportExportDashboard from "./ass_pages/activity_domains/HeroImportExportDashboard";
import HeroPremiumTradeMap from "./ass_pages/activity_domains/HeroPremiumTradeMap";
import AvailableFieldWorks from "./ass_pages/activity_domains/AvailableFieldWorks";
import { useDispatch } from "react-redux";
import { loginSuccess } from "./store/reducers/authSlice";
import { getUser } from "./helpers/auth_helper";
import LoginModal1 from "./ass_overlay_components/LoginModal1";
import AccountLayout from "./ass_components/account/regular/AccountLayout";
import Dashboard from "./ass_pages/account/regular/Dashboard";
import Orders from "./ass_pages/account/regular/Orders";
import Sales from "./ass_pages/account/regular/Sales";
import Earnings from "./ass_pages/account/regular/Earnings";
import PersonalHub from "./ass_pages/account/business/PersonalHub";
import CategoryCatalog from "./ass_components/product-instance-components/CategoryCatalog";
import ProductInstanceDetails from "./ass_components/product-instance-components/ProductInstanceDetails";

function App() {



    const stripePromise = loadStripe("pk_test_XXXXXXXXXXXXXXXXXXXX");
    const dispatch = useDispatch();

    <Elements stripe={stripePromise}>
        <HarvestBillingWithStripe />
    </Elements>

  const domain_type = useSelector((state) => state.domain.domain, shallowEqual);
  // Fetch current country based on IP
  const actualCountry = useSelector((state) => state.country.country.value);

    useEffect(() => {
        getUser().then((user) => {
            if (user) {
                dispatch(loginSuccess(user));
            }
        });
    }, [dispatch]);

  return (
    <>
    <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
    }}>
    {/* Alertes du compte connecté, empilées : mot de passe (urgent) puis documents */}
    <div className="account-alerts">
        <PasswordChangeAlert />
        <DocumentsPendingAlert />
    </div>
    <Routes>
      <Route path="/" element={<Layout />}>
       <Route index element={domain_type === "agro" ? <Home /> : <HomePastoral />}/>
          <Route
              path="/catalog/category/:subCategoryId"
              element={<CategoryCatalog />}
          />
          <Route
              path="/products/:subCategoryId/:productInstanceId"
              element={<ProductInstanceDetails />}
          />
       <Route path='map' element={actualCountry === "Togo" ? <TogoMap /> : <AvailableProducersCardView />} />
          {/*<Route path='map' element={actualCountry === "Togo" ? <TogoMap /> : <DefaultCountry />} />*/}
       <Route path="/producers" element={<AvailableProducers />}/>
       <Route path="/import-export-dashboard" element={<HeroImportExportDashboard />} />
          <Route path="/import-export-premium" element={<HeroPremiumTradeMap />} />
          <Route path="/speculators" element={<AvailableSpeculators />}/>
          <Route path="/traders" element={<AvailableTraders />}/>
          <Route path="resellers" element={<Resellers />}/>
       <Route path="about" element={<About />}/>
       <Route path="agro-coach" element={<Coach />}/>
          <Route path="agri-jobs" element={<AvailableFieldWorks />}/>
       <Route path="contact" element={<Contact />}/>
       <Route path="login" element={<Login />}/>
       <Route path="signup" element={<SignUp />}/>
          <Route path="/signup-success" element={<AfterSignup />} />
          <Route path="signup1" element={<SignUpSaved />}/>
       <Route path="wishlist" element={<WishList />}/>
       <Route path="compare-products" element={<CompareProducts />}/>
       <Route path="/product/:id" element={<ProductDetails />} />
       <Route path="publications" element={<Blogs />}/>
       <Route path="forgot-password" element={<ForgotPassword />}/>
       <Route path="reset-password" element={<ResetPassword />}/>
       <Route path="change-password" element={<ChangePassword />}/>
       <Route path="set-password" element={<SetPassword />}/>
          <Route path="account/documents" element={<MyDocuments />}/>
          <Route path="search" element={<SearchResults />}/>
       <Route path="blog/:id" element={<SingleBlog />}/>
          <Route path="general-informations" element={<GeneralInformations />}/>
       <Route path="shipping-policy" element={<ShippingPolicy />}/>
          <Route path="pre-shipping-policy" element={<PreShippingPolicy />}/>
          <Route path="delivery-policy" element={<DeliveryPolicy />}/>
          <Route path="account-policy" element={<AccountPolicy />}/>
          <Route path="account-security-policy" element={<AccountSecurityPolicy />}/>
          <Route path="payment-policy" element={<PaymentPolicy />}/>
          <Route path="cancellation-policy" element={<CancellationPolicy />}/>
          <Route path="assiganto-cargo" element={<AssigantoCargo />}/>
          <Route path="getting-started" element={<GettingStarted />}/>
          <Route path="refund-policy" element={<RefundPolicy />}/>
       <Route path="terms-and-conditions" element={<TermsAndConditions />}/>
       <Route path="product-details" element={<SingleProduct />}/>
       <Route path="cart" element={<Cart />}/>
       <Route path="checkout" element={<Checkout />}/>
       <Route path="hero-registration" element={<HeroPackSignUp />}/>
          <Route path="/pricing" element={<PricingPlansImproved />} />
          <Route path="/pricing/producers" element={<ProducersPricingPlansImproved />} />
          <Route path="/pricing/speculators" element={<SpeculatorsPricingPlans />} />
          <Route path="/pricing/traders" element={<TradersPricingPlans />} />
          <Route path="harvest-billing-selector" element={<HarvestBillingSelector />}/>
          <Route path="billing-and-payment-method" element={<HarvestBillingAndPaymentMethodSelector />}/>
          <Route path="/payment-strip" element={<StripeWrapper />}/>
          <Route path="/equipement/:id" element={<EquipmentDetails />} />
      </Route>

        <Route path="/regular" element={<AccountLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route path="sales" element={<Sales />} />
            <Route path="earnings" element={<Earnings />} />
        </Route>
        <Route path="/account" element={<PersonalHub />} />
    </Routes>
        <LoginModal1 />
    </BrowserRouter>
    </>
  );
}

export default App;
